export default __webpack_public_path__ + "static/media/log2x.343ec32d.png";